import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import Swal from "sweetalert2";
import { Button, Col, Row, Form } from "react-bootstrap";
import { Formik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import profileIcon from "../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg"
import "../userInfo/Users.css";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { FeatureDetail, ISubscriptionFeature } from "src/helper/interfaces";
import { ISubscriptionPlans } from "src/helper/interfaces";
import Cookies from "js-cookie";
import crossIcon from "../../../assets/img/icons/cross-svgrepo-com.svg"
import plusIcon from "../../../assets/img/icons/plus-svgrepo-com.svg"
import minusIcon from "../../../assets/img/icons/minus-svgrepo-com.svg"
import LoadingGif from "src/components/layout/Loader";
interface InitialValuesType {
   _id: string,
   subscription_type: string,
   amount: string,
   subscription_duration: string,
   subscription_text: string,
   description_heading: string,
   description_points: string[],
   background_color: string,
   icon: string | null,
   all_features: FeatureDetail[];
   features: string[]
}
interface IFeatures {
   _id: string;
   feature_id: string;
   name: string;
   description: string;
   type: string;
   is_deleted: boolean;
}

const getAllSubscriptionPlans = async (token: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/subscription-plans`, {
      headers: {
         "x-access-token": token
      }

   })
};

const getAllSubscriptionFeatures = async (token: string) => {
   return await axios.get(`${AppConfig?.DEV_SERVER}/subscription-features`, {
      headers: {
         "x-access-token": token
      },
      params: {
         type: "all"
      }
   })
}

const SubscriptionPlans = () => {
   const initialValues: InitialValuesType = {
      _id: "",
      subscription_type: "",
      amount: "",
      subscription_duration: "",
      subscription_text: "",
      description_heading: "",
      description_points: [],
      background_color: "",
      icon: null,
      all_features: [],
      features: []
   };

   const [plans, setPlans] = useState<ISubscriptionPlans[]>([]);
   const [features, setFeatures] = useState<ISubscriptionFeature[]>([]);
   const [selectedFeatures, setSelectedFeatures] = useState<string[]>([]);

   const [inputs, setInputs] = useState(initialValues);
   const [selectedPlan, setSelectedPlan] = useState(initialValues);
   const [editMode, setEditMode] = useState(false);

   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const Token = Cookies.get("token");
   const [iconFile, setIconFile] = useState<File | null>(null);


   const handleFormSubmit = async (formInput: any) => {
      const formData = new FormData();

      // console.log(formInput);

      formData.append('subscription_type', formInput.subscription_type);
      formData.append('amount', formInput.amount);
      formData.append('subscription_duration', formInput.subscription_duration);
      formData.append('subscription_text', formInput.subscription_text);
      formData.append('description_heading', formInput.description_heading);
      // formData.append('features', formInput.features);
      Object.values(selectedFeatures).map((data, key) => {
         formData.append('features', data);
      })

      if (formInput.icon != "" && formInput.icon != undefined) {
         formData.append('icon', formInput.icon);
      }

      if (!Token) return;

      if (editMode) {
         // Add new food item
         dispatch(startLoading());
         if (selectedPlan != null) {
            if (selectedPlan?._id) {

               await axios({
                  url: `${AppConfig.DEV_SERVER}/subscription-plan/${selectedPlan?._id}`,
                  method: "PUT",
                  headers: {
                     'content-type': 'multipart/form-data',
                     "x-access-token": Token,
                  },
                  data: formData,
               }).then(async (res) => {
                  if (res?.data?.status_code !== 200) {
                     setEditMode(false);
                     dispatch(stopLoading());

                     Swal.fire({
                        position: "center",
                        icon: "error",
                        title: `${res?.data?.msg}`,
                        showConfirmButton: false,
                        timer: 2000
                     }).then(() => {
                        // resetForm();

                     })
                  }
                  else {
                     if (res?.data?.status_code === 200) {
                        // dispatch(stopLoading());
                        setEditMode(false)
                        setTimeout(() => {
                           Swal.fire({
                              position: "center",
                              icon: "success",
                              title: "Successfully Updated",
                              text: `${res?.data?.msg}`,
                              showConfirmButton: false,
                              timer: 1000
                           }).then(() => {
                           // resetForm();
                              getAllSubscriptionPlans(Token)
                                 .then((res) => {
                                    if (res?.data?.status_code === 200) {
                                       const data = res?.data?.data;

                                       setPlans(data?.data);
                                       dispatch(stopLoading());
                                    }
                                 })
                                 .catch((err: any) => {
                                    console.log(err);
                                 })
                           })
                        }, 1500)

                     }
                  }
               })

            }
         }
      }
   }



   const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = event.target;

      setSelectedPlan({ ...selectedPlan, [name]: value });
   }

   const clickOnEdit = (id: string, type: string) => {
      const servicToEdit = plans?.find((plan: ISubscriptionPlans) => plan._id === id);
      if (servicToEdit !== undefined) {

         setSelectedPlan({
            _id: servicToEdit?._id,
            subscription_type: servicToEdit?.subscription_type,
            amount: servicToEdit?.amount,
            subscription_duration: servicToEdit?.subscription_duration,
            subscription_text: servicToEdit?.subscription_text,
            description_heading: servicToEdit?.description_heading,
            description_points: [],
            background_color: servicToEdit?.background_color,
            icon: servicToEdit?.icon,
            all_features: servicToEdit?.AllFeatures,
            features: servicToEdit?.features
         });
         setSelectedFeatures(servicToEdit?.features)
      }
      setEditMode(true);
   }


   useEffect(() => {
      if (Token) {
         dispatch(startLoading());
         getAllSubscriptionPlans(Token)
            .then((res) => {
               if (res?.data?.status_code === 200) {
                  const data = res?.data?.data;

                  setPlans(data?.data);
                  dispatch(stopLoading());
               }
            })
            .catch((err: any) => {
               console.log(err);
            })
      }
   }, [Token]);

   useEffect(() => {
      if (Token) {

         getAllSubscriptionFeatures(Token)
            .then((res) => {
               if (res?.data?.status_code === 200) {
                  const data = res?.data?.data;

                  setFeatures(data?.data);
               }
            })
            .catch((err: any) => {
               console.log(err);
            })
         // .finally(() => {
         //    dispatch(stopLoading());
         // });
      }
   }, [editMode]);

   // const onCreate = () => {
   //    setEditMode(true);
   //    setSelectedPlan({
   //       _id: "",
   //       subscription_type: "",
   //       amount: "",
   //       subscription_duration: "",
   //       subscription_text: "",
   //       description_heading: "",
   //       description_points: [],
   //       background_color: "",
   //       icon: null,
   //       all_features: [],
   //       features: []

   //    })
   // }


   const handleCheckboxChange = (feature_id: string) => {

      setSelectedFeatures((prevSelected) =>
         prevSelected.includes(feature_id)
            ? prevSelected.filter((id) => id !== feature_id) // Remove if already selected
            : [...prevSelected, feature_id] // Add if not selected
      );

   };


   return (
      <MainLayout>

         <div className="mt-3 mb-3">

            <div className="card category-main me-2 p-md-4" >
               {
                  loading ? <LoadingGif /> : ""
               }

               {editMode ? (
                  <div className="modal fade show d-block" role="dialog">
                     <div className="modal-dialog">
                        <div className="modal-content">
                           <div className="modal-header">
                              <button
                                 type="button"
                                 className="close"
                                 onClick={() => {
                                    setEditMode(false)
                                    setSelectedFeatures([]);
                                 }}
                                 style={{ outline: "none", border: "0px" }}
                              >
                                 <img src={crossIcon} alt="hide-icon" style={{ height: "20px", width: "20px" }} />
                              </button >
                              <h4 className="modal-title">  Update Subscription</h4>
                           </div>
                           <div className="modal-body gap-2">
                              {/* <div className="d-flex flex-column pb-2">
                                 <label htmlFor="amount" className="text-start pb-2">
                                    Icon
                                 </label>
                                 <input
                                    name="icon"
                                    type="file"
                                    className="form-control"
                                    onChange={handleFileChange}
                                 />
                              </div> */}

                              <div className="d-flex flex-column pb-2">
                                 <label htmlFor="amount" className="text-start pb-2">
                                    Amount
                                 </label>
                                 <input
                                    type="number"
                                    name="amount"
                                    value={selectedPlan?.amount}
                                    id="amount"
                                    className="form-control"
                                    onChange={handleChange}
                                 />
                              </div>

                              <div className="d-flex flex-column pb-2">
                                 <label htmlFor="subscription_type" className="text-start pb-2">
                                    subscription Type
                                 </label>
                                 <input
                                    type="text"
                                    name="subscription_type"
                                    value={selectedPlan?.subscription_type}
                                    id="subscription_type"
                                    className="form-control"
                                    onChange={handleChange}
                                    readOnly
                                 />
                              </div>
                              <div className="d-flex flex-column pb-2">
                                 <label htmlFor="subscription_duration" className="text-start pb-2">
                                    subscription Duration
                                 </label>
                                 <input
                                    type="text"
                                    name="subscription_duration"
                                    value={selectedPlan?.subscription_duration}
                                    id="subscription_duration"
                                    className="form-control"
                                    onChange={handleChange}
                                 />
                              </div>
                              <div className="d-flex flex-column pb-2">
                                 <label htmlFor="background_color" className="text-start pb-2">
                                    Background color
                                 </label>
                                 <input
                                    type="text"
                                    name="background_color"
                                    value={selectedPlan?.background_color}
                                    id="background_color"
                                    className="form-control"
                                    onChange={handleChange}
                                    readOnly
                                 />
                              </div>
                              <div className="d-flex flex-column pb-2">
                                 <label htmlFor="amount" className="text-start pb-2">
                                    Select Features
                                 </label>

                                 <div >
                                    {features.map((feature, index) => (
                                       <div key={index} style={{ marginBottom: "8px" }} className="text-start form-control">
                                          <input
                                             type="checkbox"
                                             id={feature.feature_id}
                                             checked={selectedFeatures.includes(feature.feature_id)}
                                             onChange={() => handleCheckboxChange(feature.feature_id)}
                                          />
                                          <label htmlFor={`feature-${index}`} style={{ marginLeft: "8px" }}>
                                             {feature?.name}
                                          </label>
                                       </div>
                                    ))}

                                 </div>


                              </div>
                              <div className="d-flex flex-column">

                                 {
                                    loading ? <LoadingGif /> : ""
                                 }

                              </div>
                           </div>

                           <div className="modal-footer">
                              <button
                                 type="button"
                                 className="btn btn-primary "
                                 onClick={() => handleFormSubmit(selectedPlan)}

                              >
                                 Update
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               ) : ""}
               {
                  <div>
                     <div className="table-responsive">
                        <table className="table table-striped card-body">
                           <thead>
                              <tr className="category-tr">
                                 <th scope="col" className="text-start ps-4">Icon</th>
                                 <th scope="col" className="text-start ps-4">Name</th>
                                 <th scope="col" className="text-start ps-4">Amout</th>
                                 <th scope="col" className="text-start ps-4">Duration</th>
                                 <th scope="col" className="text-start ps-4">Features</th>
                                 <th scope="col" className="text-start ps-4">Values</th>


                                 <th scope="col" className="col-lg-2 ps-4 ">Action</th>
                              </tr>
                           </thead>
                           <tbody>
                              {
                                 plans && plans?.map((data: ISubscriptionPlans) => {


                                    return (
                                       <tr key={data?._id}>

                                          <td className="text-start align-content-center">
                                             {
                                                data?.icon ?
                                                   <img src={data?.icon} alt="profile-pic" className="profile-pic" style={{ background: `${data?.background_color}` }} />
                                                   :
                                                   <span className="d-flex align-items-center ">
                                                      <img src={profileIcon} alt="profileIcon" className="profile-pic" />
                                                   </span>
                                             }
                                          </td>

                                          <td className="text-start align-content-center ps-4">
                                             <span className="">
                                                {data?.subscription_type}
                                             </span>

                                          </td>

                                          <td className="icon-td align-content-center text-start ps-4">
                                             {data?.amount}
                                          </td>
                                          <td className="icon-td align-content-center text-start ps-4">
                                             {data?.subscription_duration}
                                          </td>
                                          <td className="icon-td align-content-center text-start ps-4">

                                             <ul>
                                                {data?.AllFeatures?.map((item, id) => {
                                                   return (
                                                      <li key={id}>{item?.name}</li>
                                                   );
                                                })}
                                             </ul>
                                          </td>
                                          <td className="icon-td align-content-center text-start ps-4">

                                             <ul>
                                                {data?.AllFeatures?.map((item, id) => {
                                                   return (
                                                      <li key={id}>{item?.description}</li>
                                                   );
                                                })}
                                             </ul>
                                          </td>

                                          <td className="align-content-center ">
                                             <div className="d-flex justify-content-center gap-3">
                                                <button className="btn btn-sm edit_btn" onClick={() => clickOnEdit(data?._id, "edit")} style={{ marginBottom: "1px" }}>
                                                   <img src={editIcon} />
                                                </button>

                                                {/* <button className="btn btn-sm delete_btn ">
                                                <img src={deleteIcon} />
                                             </button> */}
                                             </div>

                                          </td>
                                       </tr>
                                    )
                                 }
                                 )
                              }

                           </tbody>
                        </table>
                     </div>


                  </div>
               }

            </div>

         </div>

      </MainLayout>
   )

};



export default SubscriptionPlans;